import help from '../../_scripts/helpers';

class FileUploader {
	constructor(props) {
		if (!this._initProps(props)) return false;

		this._binds();
		this._initRequired();
		this._addListeners();
	}
	_initProps(props) {
		if (!props.root && !props.element) return false;
		this.props = props;

		this.root = props.element || document.querySelector(`[${props.root}]`);

		if (this.root.hasAttribute(`${props.root}-inited`)) return false;
		this.root.setAttribute(`${props.root}-inited`, true);

		this.addButton = this.root.querySelector(`[${props.root}-button]`);
		this.list = this.root.querySelector(`[${props.root}-list]`);
		this.error = this.root.querySelector(`[${props.root}-error]`);

		this.itemTemplate = this.root.querySelector(`[${props.root}-item]`);
		this.itemTemplate.remove();

		this.filesList = [];

		return true;
	}
	_binds() {
		['_onChange', '_removeItem'].forEach(f => this[f] = this[f].bind(this));
	}
	_addListeners() {
		this.addButton.addEventListener('change', this._onChange);
	}
	_removeListeners() {
		this.addButton.removeEventListener('change', this._onChange);
	}
	_onChange(e) {
		this.root.classList.remove('is-error');
		this._updateFilesList(e.target);
	}
	_initRequired() {
		this._isRequired = this.root.hasAttribute('data-required');
		this.root.removeAttribute('required');
		this.required = false;
	}
	_addItem(name) {
		let newItem = this.itemTemplate.cloneNode(true),
			nameElement = newItem.querySelector(`[${this.props.root}-name]`),
			deleteButton = newItem.querySelector(`[${this.props.root}-delete]`);

		nameElement.innerHTML = name;
		deleteButton.name = name;
		deleteButton.addEventListener('click', this._removeItem);


		this.list.appendChild(newItem);
		setTimeout(_ => {
			newItem.classList.add('is-show');
		}, 0);

		this.isValid();
	}
	_removeItem(e) {
		let name = e.currentTarget.name,
			removedIndex = false, removedName;

		[...this.list.children].forEach((item, index) => {
			let itemNameElement = item.querySelector(`[${this.props.root}-name]`),
				itemName = help.normilizeString(itemNameElement.innerText),
				targetName = help.normilizeString(name);

			if (itemName === targetName) {
				removedName = targetName;
				removedIndex = index;
			}
		});

		if (removedIndex !== false) {
			this.list.children[removedIndex].classList.remove('is-show');
			setTimeout(_ => {
				this.list.children[removedIndex].remove();
			}, 250);
			this._removeFile(removedName);
		}

		this.isValid();
	}
	_removeFile(name) {
		let removedIndex = false;

		this.filesList.forEach((file, index) => {
			let fileName = help.normilizeString(file.name),
				removedName = help.normilizeString(name);

			if (fileName === removedName) {
				removedIndex = index;
			}
		});

		if (removedIndex !== false) this.filesList.splice(removedIndex, 1);
	}
	_updateFilesList(fileInput) {
		let newFilesList = fileInput.files;

		for (let i = 0; i < newFilesList.length; i ++) {
			this.filesList.push(newFilesList[i]);
			this._addItem(newFilesList[i].name);
		}

		this.addButton.value = null;
	}
	_validateCount() {
		if (this.filesList.length <= this.addButton.dataset.maxCount){
			return true;
		} else {
			this.errorMsg = `Вы превысили лимит по числу загружаемых файлов`
			return false;
		}
	}
	_validateFileSize() {
		let isValid = true;

		this.filesList.forEach((file, index) => {
			if (!((file.size / Math.pow(1024,2)) <= this.addButton.dataset.maxMb)){
				isValid = false;
				this.errorMsg = `Размер файла <b>${file.name}</b> превышает максимально допустимый в ${this.addButton.dataset.maxMb} Мбайт`;
			}
		});

		return isValid;
	}
	_isValid() {
		this._isCountValid = this._validateCount();
		this._isSizeValid = this._validateFileSize();

		if (this._isCountValid && this._isSizeValid){
			this._isInputValid = true;
		} else {
			this._isInputValid = false;
		}

		if (this._isInputValid) {
			this.root.classList.remove('is-error');
		} else {
			this.error.innerHTML = this.errorMsg;
			this.root.classList.add('is-error');
		}
	}
	getFilesList() {
		return this.filesList;
	}
	isRequired() {
		return this._isRequired;
	}
	isValid() {
		this._isValid();
		return this._isInputValid;
	}
	setFocus() {
		this.addButton.focus();
	}
	getName() {
		return this.root.name;
	}
	setError(text) {
		if (this.error) {
			this.error.innerHTML = text;
			this.root.classList.add('is-error');
		}
	}
	isDestroyed() {
		return this.isDestroyed;
	}
	destroy(deleteDom) {
		this.isDestroyed = true;

		this._removeListeners();
		if (deleteDom) {
			this.root.remove();
		}
	}
}

class FileUploaders {
	constructor(props) {
		if (!props.root) return false;

		this.wrapper = props.wrapper || document;
		this.inputs = [];

		[...this.wrapper.querySelectorAll(`[${props.root}]:not([${props.root}-inited])`)].forEach(inputElement => {
			this.inputs.push(
				new FileUploader({
					root: props.root,
					element: inputElement
				})
			);
		});
	}
}

export {FileUploaders, FileUploader};